import ArpEffect from './ArpEffect.js';
import ParameterEffect from './ParameterEffect.js';
import TimingEffect from './TimingEffect.js';
import Flush from './messaging/Flush.js';
import Message from './messaging/Message.js';
import NoteDisplay from './NoteDisplayEffect.js';
import AccumulatorEffect from './mappable/AccumulatorEffect.js';
import MidiOutputter from './MidiOutputter.js';
import ChordRhythmEffect from './ChordRhythmEffect.js';
import ChordSculptorEffect from './ChordSculptorEffect.js';
import MidiInterfaceEffect from './MidiInterfaceEffect.js';
import MidiDelayEffect from './MidiDelayEffect.js';
import MidiEffectRack from './MidiEffectRack.js';
import HarmonyEffect from './HarmonyEffect.js';
import MicroTuningEffect from './MicroTuningEffect.js';
import AlternateTuningEffect from './AlternateTuningEffect.js';
import WarpEffect from './WarpEffect.js';
import TidalEffect from './TidalEffect.js';
import LinkedTidal from './LinkedTidal.js';
import LimitEffect from './LimitEffect.js';
import EveryEffect from './EveryEffect.js';
import MidiCCEffect from './MidiCCEffect.js';
import Steps from './scripting/Steps.js';
import Notes from './scripting/Notes.js';
import BeatRepeat from './scripting/BeatRepeat.js';
import Grab from './scripting/Grab.js';
import GrabTime from './scripting/GrabTime.js';
import AltEffect from './scripting/AltEffect.js';
import AltNEffect from './scripting/AltNEffect.js';
import BeatEffect from './scripting/BeatEffect.js';
import ThresholdEffect from './scripting/ThresholdEffect.js';
import UserScriptEffect from './scripting/UserScriptEffect.js';
import ControlParametersEffect from './mappable/ControlParametersEffect.js';
import ConditionalParametersEffect from './mappable/ConditionalParametersEffect.js';
import PlaneParametersEffect from './mappable/PlaneParametersEffect.js';
import ScaleEffect from './scales/ScaleEffect.js';
import PatternSwitchEffect from './scripting/PatternSwitchEffect.js';
import PolyEffect from './scripting/PolyEffect.js';
import DensityEffect  from './scripting/DensityEffect.js';
import Roll from './scripting/Roll.js';
import GateEffect from './scripting/GateEffect.js';
import StatsEffect from './scripting/StatsEffect.js';
import SparseEffect from './SparseEffect.js';
import JakiEffect from './jaki/JakiEffect.js';
import GenerativeChordsEffect from './chords/GenerativeChordsEffect.js';
import {OctaveEffect, VoiceEffect, ChordEffect} from './chords/ChordEffects.js';
import {FlatEffect, ThickEffect, SplitEffect} from './chords/TransformEffects.js';
import {
    Figure,
    Any,
    Skip,
    Flam,
    Double,
    Times,
    Later,
    Max,
    REvery,
    First,
    Last,
    Dash1,
    Dash2,
    Dot,
    Accent,
    Staccato,
    Piano,
    Pianissimo,
    Rest,
    Otherwise,
    Legato,
    Regular,
} from 'effects/midi/jaki/RuleEffects.js';

export const nameToMidiEffect = {
    'Accumulator': track => new AccumulatorEffect(track),
    'Arpeggiator': track => new ArpEffect(track),
    'Beat': track => new BeatEffect(track),
    "Control Parameters": track => new ControlParametersEffect(track),
    "Conditional Parameters": track => new ConditionalParametersEffect(track),
    "Plane Parameters": track => new PlaneParametersEffect(track),
    'Every': track => new EveryEffect(track),
    'Limit': track => new LimitEffect(track),
    'Parameterizer': track => new ParameterEffect(track),
    'Timing': track => new TimingEffect(track),
    'Midi Outputter': track => new MidiOutputter(track),
    'Midi CC': track => new MidiCCEffect(track),
    'Midi Interface': track => new MidiInterfaceEffect(track),
    'Harmony': track => new HarmonyEffect(track),
    'Alternate Tuning': track => new AlternateTuningEffect(track),
    'Micro Tuning': track => new MicroTuningEffect(track),
    'Midi Delay': track => new MidiDelayEffect(track),
    'Chord Rhythm': track => new ChordRhythmEffect(track),
    'Chord Sculptor': track => new ChordSculptorEffect(track),
    'Warp': track => new WarpEffect(track),
    'Tidal': track => new TidalEffect(track),
    'Linked Tidal': track => new LinkedTidal(track),
    'Midi Effect Rack': track => new MidiEffectRack(track),
    'Beat Repeat': track => new BeatRepeat(track),
    'Pattern Switch': track => new PatternSwitchEffect(track),
    'Steps': track => new Steps(track),
    'Notes': track => new Notes(track),
    'Grab': track => new Grab(track),
    'Grab Time': track => new GrabTime(track),
    'Alternate': track => new AltEffect(track),
    'Scale': track => new ScaleEffect(track),
    "Flush": track => new Flush(track),
    "Message": track => new Message(track),
    'User Script': track => new UserScriptEffect(track),
    'Threshold': track => new ThresholdEffect(track),
    'Roll': track => new Roll(track),
    'Alternate N': track => new AltNEffect(track),
    'Density': track => new DensityEffect(track),
    'Poly': track => new PolyEffect(track),
    'Note Display': track => new NoteDisplay(track),
    'Sparse': track => new SparseEffect(track),
    'Midi Gate': track => new GateEffect(track),
    'Stats': track => new StatsEffect(track),
    'Jaki': track => new JakiEffect(track),
    'Figure': track => new Figure(track),
    'Max': track => new Max(track),
    'First': track => new First(track),
    'Last': track => new Last(track),
    'Dash 1': track => new Dash1(track),
    'Dash 2': track => new Dash2(track),
    'Dot': track => new Dot(track),
    'Accent': track => new Accent(track),
    'Staccato': track => new Staccato(track),
    'Piano': track => new Piano(track),
    'Pianissimo': track => new Pianissimo(track),
    'Rest': track => new Rest(track),
    'Otherwise': track => new Otherwise(track),
    'Legato': track => new Legato(track),
    'R.Every': track => new REvery(track),
    'Double': track => new Double(track),
    'Later': track => new Later(track),
    'Skip': track => new Skip(track),
    'Any': track => new Any(track),
    'Times': track => new Times(track),
    'Flam': track => new Flam(track),
    'Regular': track => new Regular(track),
    'Chord Type': track => new ChordEffect(track),
    'Generative Chords': track => new GenerativeChordsEffect(track),
    'Voice': track => new VoiceEffect(track),
    'Octave': track => new OctaveEffect(track),
    'Split': track => new SplitEffect(track),
    'Flat': track => new FlatEffect(track),
    'Thick': track => new ThickEffect(track),
};


export function getMidiEffect(json, track) {
    if (json.name in nameToMidiEffect) {
        return nameToMidiEffect[json.name](track);
    }
    return undefined;
}
